module.exports = __webpack_public_path__ + "6daf247c920f46c463d87b021a92b64b.png";